import clsx from "clsx";
import { memo } from "react";

import classes from "./styles.module.scss";
import type { ILineProps } from "./types";

export const Line = memo(function Line(props: ILineProps) {
  const { lineColor } = props;

  return <div className={clsx(classes.statusLine, lineColor)} />;
});
Line.displayName = "Line";
